'use strict';
var timeLines = document.getElementsByClassName("js-timeline");
if (timeLines.length) {
    document.onscroll = function () {
        for (var key in timeLines) {
            if (timeLines.hasOwnProperty(key)) {
                animateTimeline(timeLines[key]);
            }
        }
    };
}
/**
 * Function that animates timeline track, by adding 'active' class to it's nodes
 * @param timeLine
 */
var animateTimeline = function (timeLine) {
    var timeLineItems = timeLine.querySelectorAll('.c-timeline__item');
    // IE11 compatible loop
    for (var index = 0; index < timeLineItems.length; index++) {
        if (timeLineItems[index].getBoundingClientRect().top <= 250) {
            if (index !== 0 && timeLineItems[index - 1].classList.contains('animating')) {
                setTimeout(function (items) {
                    animateTimeline(items);
                }, 1000, timeLine);
                break;
            }
            if (!timeLineItems[index].classList.contains('active')) {
                timeLineItems[index].classList.add('active');
                timeLineItems[index].classList.add('animating');
            }
            setTimeout(function (item) {
                item.classList.remove('animating');
            }, 900, timeLineItems[index]);
        }
    }
};
